import React from "react";
import { domToReact } from "html-react-parser";
import parse from "html-react-parser";
import DOMPurify from "dompurify";

export default function HtmlWithPdfLinks({ bodyHtml, fetchPdf }) {
  // 1. Clean the HTML first
  const cleanHtml = DOMPurify.sanitize(
    bodyHtml
      .replace(/MARGIN:/gi, "margin:") // normalize margin
      .replace(/TEXT-ALIGN:/gi, "text-align:")
      .replace(/LINE-HEIGHT:/gi, "line-height:")
      .replace(/cm/g, "px") // convert cm to px
      .replace(/<o:p>.*?<\/o:p>/g, "") // remove Word tags
  );

  // 2. Transform links
  const transform = (node, index) => {
    if (node.type === "tag" && node.name === "a") {
      const href = node.attribs.href || "";

      // EGAnchorURL ?ID=123
      const egMatch = href.match(/[?&]ID=(\d+)/i);
      if (egMatch) {
        const id = parseInt(egMatch[1], 10);
        const children = domToReact(node.children, { replace: transform });
        return (
          <span
            key={index}
            style={{
              cursor: "pointer",
              color: "blue",
              textDecoration: "underline",
            }}
            onClick={(e) => {
              e.preventDefault();
              fetchPdf(id);
            }}
          >
            {children}
          </span>
        );
      }

      // legislativedetails ?DocID=97000
      const docMatch = href.match(/[?&]DocID=(\d+)/i);
      if (docMatch) {
        const documentId = parseInt(docMatch[1], 10);
        const children = domToReact(node.children, { replace: transform });
        return (
          <span
            key={index}
            style={{
              cursor: "pointer",
              color: "blue",
              textDecoration: "underline",
            }}
            onClick={(e) => {
              e.preventDefault();
              window.open(
                `/law-library/document?documentID=${documentId}`,
                "_blank"
              );
            }}
          >
            {children}
          </span>
        );
      }

      // [LLAnchorURL] → lawlibrary subdocument
      const subDocMatch = href.match(/[?&]subdocumentID=(\d+)/i);
      if (href.includes("[LLAnchorURL]") && subDocMatch) {
        const subdocumentId = parseInt(subDocMatch[1], 10);
        const children = domToReact(node.children, { replace: transform });
        return (
          <span
            key={index}
            style={{
              cursor: "pointer",
              color: "blue",
              textDecoration: "underline",
            }}
            onClick={(e) => {
              e.preventDefault();
              window.open(
                `/law-library/document?subdocumentId=${subdocumentId}`,
                "_blank"
              );
            }}
          >
            {children}
          </span>
        );
      }
    }
  };

  return <div>{parse(cleanHtml, { replace: transform })}</div>;
}
